import React from "react";
import classNames from "classnames";
import "./index.scss";

import LinkDownload from "../LinkDownload";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const SectionItemLinkdownload = ({ item, column }) => (
  <div className={classNames("sectionItemLinkdownload", column.className)}>
    <LinkDownload
      title={getTranslateTitle(column.title)}
      actionName={column.actionName}
      data={item}
      icon={"excel"}
    />
  </div>
);

export default SectionItemLinkdownload;
